// @flow
import React from 'react';
import { Container, Row, Col } from 'reactstrap';
// eslint-disable-next-line import/named
import { injectIntl, type IntlShape } from 'react-intl';

// Components
import Price from 'components/atoms/Price';
import Checkbox from 'components/atoms/Checkbox';

// Utils
import { clickEvent } from 'utils/adaConfigurations/customEvents';

import './SelectAllButton.scss';

type Props = {
  isSelected: boolean,
  price?: number,
  discountedPrice?: number,
  onClick: () => void,
  intl: IntlShape
};

const SelectAllButton = ({
  isSelected,
  price,
  discountedPrice,
  onClick,
  intl
}: Props) => {
  const ns = SelectAllButton.block;
  return (
    <Container
      className={ns}
      onClick={onClick}
      onKeyUp={clickEvent}
      role={'listitem'}
    >
      <Row>
        <Col xs={8} md={discountedPrice ? 9 : 10} className={`${ns}__name`}>
          {intl.formatMessage({
            id: 'c8.common.all'
          })}
        </Col>
        <Col
          xs={2}
          md={discountedPrice ? 2 : 1}
          className={`${ns}__col ${ns}__col--center ${ns}__col--vertical p-0`}
        >
          {Boolean(discountedPrice) && (
            <span className={`${ns}__price ${ns}__price--promotion`}>
              <Price value={price} />
            </span>
          )}
          <span className={`${ns}__price`}>
            <Price value={discountedPrice ? discountedPrice : price} />
          </span>
        </Col>
        <Col xs={2} md={1} className={`text-center p-0`}>
          <Checkbox isSelected={isSelected} />
        </Col>
      </Row>
    </Container>
  );
};

SelectAllButton.block = 'select-all-button';

export default injectIntl(SelectAllButton);



// WEBPACK FOOTER //
// ./src/components/atoms/SelectAllButton/SelectAllButton.js